<template>
	<v-overlay
		ref="selectOverlay"
		:model-value="isActive"
		:class="overlayClass"
		opacity="0.7"
		scrim="secondary"
		width="100%"
		disabled
		persistent
		eager
	>
		<v-banner bg-color="primary" lines="one" :icon="bannerIcon">
			<template #text>
				<span class="text-h6">{{ bannerText }}</span>
			</template>

			<template #actions>
				<v-btn icon="mdi-close" @click="cancelSelection"></v-btn>
			</template>
		</v-banner>
	</v-overlay>
</template>

<script>
export default {
	name: "VMetadataSelectOverlay",

	inject: ["textSelect", "locationSelect"],

	props: {
		type: {
			type: String,
			default: "text",
			validator: (value) => ["text", "location"].includes(value),
		},
	},

	emits: ["close"],

	setup() {},

	data() {
		return {};
	},
	computed: {
		selectState() {
			return this.type === "text" ? this.textSelect : this.locationSelect;
		},
		isActive() {
			return !!this.selectState?.ctx?.visible;
		},
		overlayClass() {
			return `${this.type}-select-overlay flex-1-1-100`;
		},
		bannerIcon() {
			return this.type === "text" ? "mdi-form-textbox" : "mdi-map-marker";
		},
		bannerText() {
			return this.type === "text" ? "Selecting text" : "Selecting location";
		},
	},

	watch: {
		isActive() {
			this.$nextTick(() => this.toggleActive());
		},
	},

	methods: {
		cancelSelection() {
			this.selectState?.cancel?.();

			if (this.selectState?.settings?.exitOnClose) {
				this.$emit("close");
			}
		},
		toggleActive() {
			const container = this.selectState?.ctx?.container;
			const bounds = this.selectState?.ctx?.bounds;
			if (!container) {
				return;
			}

			if (this.isActive) {
				container.style.display = "none";

				const overlayEl = document.querySelector(
					`.${this.type}-select-overlay`,
				);
				if (overlayEl) {
					overlayEl.style.clipPath = `
						polygon(
							0% 0%, 0% 100%,
							${bounds.left}px 100%,
							${bounds.left}px ${bounds.top}px,
							${bounds.right}px ${bounds.top}px,
							${bounds.right}px ${bounds.bottom}px,
							${bounds.left}px ${bounds.bottom}px,
							${bounds.left}px 100%,
							100% 100%, 100% 0%
					)
				`;
				}
			} else {
				container.style.display = "";
				const overlayEl = document.querySelector(
					`.${this.type}-select-overlay`,
				);
				if (overlayEl) {
					overlayEl.style.clipPath = "";
				}
			}
		},
	},
};
</script>

<style lang="scss"></style>
